// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_9-0";
export var skeletonCard = "_9-1";